import { useEffect, useRef } from 'react';

/**
 * Calls the latest handler for every keydown on the page, subscribing once.
 *
 * @param {Function} handler - receives the KeyboardEvent
 */
export const useWindowKeydown = handler => {
  const savedHandler = useRef(handler);

  useEffect(() => {
    savedHandler.current = handler;
  });

  useEffect(() => {
    const listener = event => savedHandler.current(event);
    window.addEventListener('keydown', listener);
    return () => window.removeEventListener('keydown', listener);
  }, []);
};
